class ctxRightClickDirective {
    constructor($parse) {
        this.restrict = 'A';
        this.$parse = $parse;
    }

    link(scope, element, attrs) {
        let fn = this.$parse(attrs.ctxRightClick);
        element.bind('contextmenu', event => {
            scope.$apply(() => {
                event.preventDefault();
                fn(scope, {$event: event});
            });
        });
    }

    static directiveFactory($parse) {
        return new ctxRightClickDirective($parse);
    }
}

ctxRightClickDirective.directiveFactory.$inject = ['$parse'];

module.exports = ctxRightClickDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/utils/ctxRightClick.directive.js